var debounce = function(func, waitTime, obj, name) {
  if (waitTime === null || typeof waitTime === "undefined") {
    waitTime = 1000;
  }
  if (waitTime < 1) {
    func.apply(obj);
    return true;
  }
  if (typeof name === "undefined" || name === null || name.length < 1) {
    name = "timeout";
  }
  clearTimeout(debounce[name]);

  debounce[name] = setTimeout(function() {
    func.apply(obj);
  }, waitTime);

};


